<template>
  <section class="menu-section" ref="menuSection" id="Menu">
    <div class="menu-container">
      <h2 class="section-title">Menu Items</h2>
      
      <div class="menu-grid">
        <!-- Menu Item -->
        <div class="menu-item" 
             v-for="(item, index) in displayedItems" 
             :key="index"
             ref="menuItems"
             :class="{ 'new-item': index >= 6 && showFullMenu }">
          <div class="menu-item-image">
            <img :src="item.image" :alt="item.name" loading="lazy">
          </div>
          <h3 class="menu-item-name">{{ item.name }}</h3>
          <p class="menu-item-description">{{ item.description }}</p>
          <div class="menu-item-footer">
            <span class="menu-item-price">{{ item.price }}</span>
            <button class="add-to-order-btn" @click="addToOrder(item)">+ Add to order</button>
          </div>
        </div>
      </div>

      <button class="view-full-menu-btn" @click="toggleMenu">
        {{ showFullMenu ? 'See Shortest Menu' : 'See Full Menu' }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MenuSection',
  data() {
    return {
      showFullMenu: false,
      menuItems: [
        {
          name: 'Cappuccino',
          description: 'Rich espresso with velvety steamed milk and foam',
          price: '$4.50',
          image: `/Images/pexels-decha-huayyai-386244-1036444.jpg`,
        },
        {
          name: 'Cold Brew',
          description: 'Smooth, refreshing, perfectly balanced cold coffee',
          price: '$5.00',
          image: `/Images/jonas-jacobsson-ujenujDrMjc-unsplash.jpg`,
        },
        {
          name: 'Caramel Latte',
          description: 'Sweet caramel blended with espresso and milk',
          price: '$5.50',
          image: `/Images/pexels-daniel-twal-2765985-4307385.jpg`,
        },
        {
          name: 'Butter Croissant',
          description: 'Flaky, buttery, baked fresh daily',
          price: '$3.50',
          image: `/Images/pexels-elkady-3892469.jpg`,
        },
        {
          name: 'Avocado Toast',
          description: 'Smashed avocado on sourdough with cherry tomatoes',
          price: '$7.00',
          image: `/Images/pexels-ahmed-rabea-2883687-4559174.jpg`,
        },
        {
          name: 'Tiramisu',
          description: 'Classic Italian dessert with espresso and mascarpone',
          price: '$6.00',
          image: `/Images/pexels-skilletsandpots-1707920.jpg`,
        },
        {
  name: 'Espresso',
  description: 'Pure, bold shot of premium Italian coffee',
  price: '$3.00',
image: `/Images/Espresso.jpg`,
},
{
  name: 'Chocolate Chip Cookie',
  description: 'Warm, gooey, packed with premium chocolate chips',
  price: '$3.00',
image: `/Images/Cookie.jpg`,
},
{
  name: 'Mocha',
  description: 'Chocolate-infused espresso with steamed milk',
  price: '$5.75',
  image: `/Images/Mocha.jpg`,
},

      ]
    }
  },
  computed: {
    displayedItems() {
      return this.showFullMenu ? this.menuItems : this.menuItems.slice(0, 6);
    }
  },
  mounted() {
    this.observeSection();
  },
  methods: {
    toggleMenu() {
      this.showFullMenu = !this.showFullMenu;
      
      // انتظر قليلاً حتى يتم إضافة العناصر للـ DOM
      if (this.showFullMenu) {
        this.$nextTick(() => {
          this.observeSection();
        });
      }
    },
    observeSection() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.2
      });

      if (this.$refs.menuItems) {
        this.$refs.menuItems.forEach((item) => {
          observer.observe(item);
        });
      }
    },
  addToOrder(item) {
    // ابعت الاسم للفورم
    this.$emit('item-added', item.name);
    
    // بعد كده انزل على textarea Special Request
    setTimeout(() => {
      const specialRequestField = document.getElementById('special');
      if (specialRequestField) {
        specialRequestField.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' // ده هيخليه في نص الشاشة
        });
        specialRequestField.focus(); // هيعمل focus على الحقل
      }
    }, 500); // استنى شوية عشان الـ emit يتنفذ الأول
  },
  }
}
</script>

<style scoped>
.menu-section {
  width: 100%;
  padding: 6rem 2rem;
  background-color: #FFF8DC;
}

.menu-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-family: 'Playfair Display', serif;
  font-size: 2.5rem;
  font-weight: 600;
  color: #6F4E37;
  text-align: center;
  margin-bottom: 4rem;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;
  margin-bottom: 3rem;
}

.menu-item {
  background-color: #FFFFFF;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(111, 78, 55, 0.08);
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.5s ease-out; /* هنا التغيير */
}

.menu-item.visible {
  opacity: 1;
  transform: translateY(0);
}

/* للكروت الجديدة فقط - حركة سلسة */
/* للكروت الجديدة - ظهور سلس */
.menu-item.new-item {
  animation: fadeInUp 0.5s ease-out forwards;
}

/* للكروت الي بتختفي - اختفاء سلس */
.menu-item.removing {
  animation: fadeOutDown 0.5s ease-out forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes fadeOutDown {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
}

.menu-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 24px rgba(111, 78, 55, 0.15);
}

.menu-item-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.menu-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.menu-item:hover .menu-item-image img {
  transform: scale(1.1);
}

.menu-item-name {
  font-family: 'Playfair Display', serif;
  font-size: 1.75rem;
  font-weight: 600;
  color: #6F4E37;
  margin: 1.5rem 1.5rem 1.75rem;
  text-align: center;
}

.menu-item-description {
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  color: rgba(139, 115, 85, 0.797);
  margin: 0 1.5rem 1.5rem;
  line-height: 1.5;
  text-align: center;
}

.menu-item-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-top: 0.3px solid #F0E6D2;
}

.menu-item-price {
  font-family: 'Playfair Display', serif;
  font-size: 1.75rem;
  font-weight: 600;
  color: #8B4513;
}

.add-to-order-btn {
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 500;
  color: rgba(139, 69, 19, 0.8);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

.add-to-order-btn:hover {
  color: #8B4513;
}

.view-full-menu-btn {
  display: block;
  margin: 0 auto;
  padding: 12px 3rem;
  background-color: #D4A574;
  color: #8B4513;
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.4s ease;
}

.view-full-menu-btn:hover {
  background-color: #8B4513;
  color: #D4A574;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 69, 19, 0.3);
}

/* Responsive */
@media (max-width: 1024px) {
  .menu-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .menu-section {
    padding: 4rem 1.5rem;
  }

  .section-title {
    font-size: 2rem;
    margin-bottom: 3rem;
  }

  .menu-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .menu-item-name {
    font-size: 1.25rem;
  }
}
</style>